import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const AttendancePage = lazy(() => import('./AttendancePage'));

export const attendanceRoutes: RouteObject[] = [
  {
    path: 'attendance',
    element: (
      <ProtectedRoute action="attendance:view">
        <AttendancePage />
      </ProtectedRoute>
    ),
  },
];
